import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// SessionWatcher must be rendered inside <BrowserRouter> so that
// useNavigate() is available. It listens for the "session-expired"
// custom event dispatched by the Axios interceptor and performs a
// clean React Router redirect to /login with a toast notification.
const SessionWatcher = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSessionExpired = () => {
      toast.warning("Your session has expired. Please log in again.", {
        toastId: "session-expired", // prevent duplicate toasts
      });
      navigate("/login", { replace: true });
    };

    window.addEventListener("session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("session-expired", handleSessionExpired);
    };
  }, [navigate]);

  return null; // renders nothing
};

export default SessionWatcher;
